(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var backdrop = document.getElementById('cart-drawer-backdrop');
    var drawer = document.getElementById('cart-drawer');
    var closeButton = document.getElementById('cart-drawer-close');
    var titleEl = document.getElementById('cart-drawer-title');
    var body = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-drawer-footer');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    var promo = document.getElementById('cart-drawer-promo');
    var promoMsg = document.getElementById('cart-drawer-promo-msg');
    var promoFill = document.getElementById('cart-drawer-promo-fill');
    var moneyRain = document.getElementById('cart-drawer-money-rain');
    var i18n = drawer.dataset;
    var currentCart = null;
    var previousItemCount = 0;
    var hasRenderedOnce = false;

    var PROMO_TARGET = 2; // collections needed to unlock the free one
    var PROMO_TRIGGER = 3; // total items once the free one is in the cart — one-time, doesn't repeat

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function triggerMoneyMoment() {
      if (!moneyRain || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      for (var i = 0; i < 7; i++) {
        (function () {
          var glyph = document.createElement('span');
          glyph.className = 'cart-drawer__money-glyph';
          glyph.textContent = '$';
          glyph.style.left = (10 + Math.random() * 80) + '%';
          glyph.style.animationDelay = Math.round(Math.random() * 250) + 'ms';
          moneyRain.appendChild(glyph);
          setTimeout(function () {
            if (glyph.parentNode) glyph.parentNode.removeChild(glyph);
          }, 1500);
        })();
      }
    }

    function updateTitle(itemCount) {
      titleEl.textContent = itemCount > 0
        ? i18n.textTitle + ' (' + itemCount + ')'
        : i18n.textTitle;
    }

    function updatePromo(itemCount) {
      if (itemCount === 0) {
        promo.hidden = true;
        return;
      }
      promo.hidden = false;

      if (itemCount >= PROMO_TARGET) {
        promoFill.style.width = '100%';
        promoMsg.textContent = i18n.textPromoUnlocked;
      } else {
        promoFill.style.width = (itemCount / PROMO_TARGET) * 100 + '%';
        promoMsg.textContent = i18n.textPromoProgress.replace('{n}', PROMO_TARGET - itemCount);
      }
    }

    function displaySubtotal(cart) {
      var freeItem = cart.item_count >= PROMO_TRIGGER ? cart.items[PROMO_TRIGGER - 1] : null;
      return freeItem ? cart.total_price - freeItem.final_price : cart.total_price;
    }

    function openDrawer() {
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        backdrop.classList.add('is-visible');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function closeDrawer() {
      backdrop.classList.remove('is-visible');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        backdrop.hidden = true;
      }, 300);
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    function renderCart(cart) {
      currentCart = cart;
      updateCartCount(cart.item_count);
      updateTitle(cart.item_count);
      updatePromo(cart.item_count);

      if (hasRenderedOnce && cart.item_count === PROMO_TARGET && previousItemCount < PROMO_TARGET) {
        triggerMoneyMoment();
      }
      previousItemCount = cart.item_count;
      hasRenderedOnce = true;

      if (cart.item_count === 0) {
        footer.hidden = true;
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<p>' + i18n.textEmpty + '</p>' +
            '<a href="' + i18n.continueUrl + '" class="cart-drawer__empty-link">' + i18n.textContinue + '</a>' +
          '</div>';
        return;
      }

      footer.hidden = false;
      subtotalEl.textContent = formatMoney(displaySubtotal(cart));

      body.innerHTML = cart.items
        .map(function (item, index) {
          var showVariant = item.variant_title && item.variant_title !== 'Default Title';
          var isFree = cart.item_count >= PROMO_TRIGGER && index === PROMO_TRIGGER - 1;
          var priceHtml = isFree
            ? '<span class="cart-drawer__item-price cart-drawer__item-price--free">' + formatMoney(item.final_price) + '</span>' +
              '<span class="cart-drawer__item-free-label">' + i18n.textFree + '</span>'
            : '<span class="cart-drawer__item-price">' + formatMoney(item.final_price) + '</span>';

          return (
            '<div class="cart-drawer__item" data-key="' + item.key + '">' +
              '<div class="cart-drawer__item-image">' +
                (item.image ? '<img src="' + item.image + '&width=180" alt="" loading="lazy">' : '') +
              '</div>' +
              '<div class="cart-drawer__item-details">' +
                '<div class="cart-drawer__item-top">' +
                  '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
                  '<button type="button" class="cart-drawer__remove" aria-label="' + i18n.textRemove + '">&times;</button>' +
                '</div>' +
                '<div class="cart-drawer__item-price-row">' + priceHtml + '</div>' +
                (showVariant ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
              '</div>' +
            '</div>'
          );
        })
        .join('');
    }

    function changeItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) {
          return response.json();
        })
        .then(renderCart);
    }

    function refreshCart() {
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(renderCart);
    }

    body.addEventListener('click', function (event) {
      var removeButton = event.target.closest('.cart-drawer__remove');
      if (!removeButton) return;
      var item = event.target.closest('.cart-drawer__item');
      changeItem(item.dataset.key, 0);
    });

    closeButton.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });

    document.addEventListener('open-cart', function () {
      openDrawer();
      refreshCart();
    });

    document.addEventListener('submit', function (event) {
      if (!event.target.matches('form[action^="/cart/add"]')) return;
      event.preventDefault();

      var formData = new FormData(event.target);

      // Each product is a single license — one per cart, no stacking quantity.
      var variantId = formData.get('id');
      var alreadyInCart = currentCart && currentCart.items.some(function (item) {
        return String(item.variant_id) === String(variantId);
      });

      if (alreadyInCart) {
        document.dispatchEvent(new CustomEvent('open-cart'));
        return;
      }

      formData.set('quantity', '1');

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function () {
          document.dispatchEvent(new CustomEvent('open-cart'));
        });
    });

    refreshCart();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.cart-icon-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('open-cart'));
      });
    });

    var trigger = document.getElementById('nav-drawer-trigger');
    var backdrop = document.getElementById('nav-drawer-backdrop');
    var drawer = document.getElementById('nav-drawer');
    var closeButton = document.getElementById('nav-drawer-close');

    if (!trigger || !drawer) return;

    function openDrawer() {
      backdrop.hidden = false;
      requestAnimationFrame(function () {
        backdrop.classList.add('is-visible');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      closeButton.focus();
    }

    function closeDrawer() {
      backdrop.classList.remove('is-visible');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        backdrop.hidden = true;
      }, 300);
    }

    trigger.addEventListener('click', openDrawer);
    closeButton.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
